import {
  DELIVERY_STATUSES_INFO,
  UNKNOWN_DELIVERY_STATUS_INFO,
} from "@/constants/deliveries";
import {
  RETRIEVAL_STATUSES_INFO,
  UNKNOWN_RETRIEVAL_STATUS_INFO,
} from "@/constants/retrievals";
import { DeliveryStage } from "@/types/api/deliveries";
import { RetrievalStage } from "@/types/api/retrievals";
import { I18nextLocale } from "@/types/types";

export function isLargeContainer(size: number): boolean {
  return size === 1800;
}

export function isValidLocale(locale: string): boolean {
  return Object.values(I18nextLocale).includes(locale as I18nextLocale);
}

export function getDeliveryStatusInfo(status?: DeliveryStage) {
  return DELIVERY_STATUSES_INFO?.[status] || UNKNOWN_DELIVERY_STATUS_INFO;
}

export function getRetrievalStatusInfo(status?: RetrievalStage) {
  return RETRIEVAL_STATUSES_INFO?.[status] || UNKNOWN_RETRIEVAL_STATUS_INFO;
}

export function getTimeString(date: Date): string {
  const shortTime = new Intl.DateTimeFormat("en", {
    timeStyle: "medium",
    hour12: false,
  });
  return shortTime.format(date).replace(/:/g, ""); // 14:01:01 becomes 140101
}

export function getDateString(date: Date): string {
  const [, month, day] = date.toDateString().split(" "); // 'Tue Nov 29 2022'
  return `${day}${month}`; // 29Nov
}

export function getDateTimeString(date: Date): string {
  return `${getDateString(date)}-${getTimeString(date)}`.trim();
}

function dayOfYear(date: Date): number {
  const start = new Date(date.getFullYear(), 0, 0);
  const diff =
    date.getTime() -
    start.getTime() +
    (start.getTimezoneOffset() - date.getTimezoneOffset()) * 60 * 1000;
  const oneDay = 1000 * 60 * 60 * 24;
  return Math.floor(diff / oneDay);
}

export function generateSixDigitNumberBasedOnDayAndTime(): string {
  const now = new Date();

  // Combine day of the year with the seconds to create a larger number
  const combinedValue =
    dayOfYear(now) * 100000 +
    now.getHours() * 3600 +
    now.getMinutes() * 60 +
    now.getSeconds();

  // Convert to 6-digit string
  const uniqueString = (combinedValue % 1000000).toString().padStart(6, "0");

  return uniqueString;
}
